export default function PrivacyNotice() {
    return (
        <p className="text-xs leading-relaxed text-gray-500 dark:text-gray-400">
            Non è richiesta alcuna registrazione: la conversione è associata a un identificativo
            anonimo. I file caricati e i Markdown generati vengono eliminati automaticamente
            un&apos;ora dopo il caricamento.
        </p>
    );
}
